const componentName = 'screenshare';
const serviceName = 'DoctorScreenshareRealtimeComponent';
const moduleName = 'doxy.realtime.components.doctor-screenshare';
export { componentName, serviceName, moduleName };
import DoctorScreenshareRealtimeComponent from './doctor/screensharing';
import doctorScreensharePopup from './doctor/doctor-screenshare-popup/doctor-screenshare-popup';

export default angular
  .module(moduleName, [doctorScreensharePopup])
  .service(serviceName, DoctorScreenshareRealtimeComponent).name;
